module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.7560/img/spinner.png"